import { v4 as uuidv4 } from 'uuid';
import { motion } from 'framer-motion';
import ReactTooltip from 'react-tooltip';
import React, { useState, useEffect } from 'react';

import './Skills.scss';
import resume from '../../assets/Resume.png';
import { urlFor, client } from '../../client';
import { AppWrap, MotionWrap } from '../../wrapper';

const Skills = () => {
  const [experiences, setExperiences] = useState([]);
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    const query = '*[_type == "experiences"]';
    const skillsQuery = '*[_type == "skills"]';

    client.fetch(query).then((data) => {
      setExperiences(data);
    });

    client.fetch(skillsQuery).then((data) => {
      setSkills(data);
    });
  }, []);

  return (
    <>
      <h2 className="head-text">Skills & Experiences</h2>
      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill) => (
            <motion.div
              key={skill.name}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: [0, 1] }}
              className="app__skills-item app__flex"
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={urlFor(skill.icon)} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="app__skills-exp" key={uuidv4()}>
          {experiences.map((experience) => (
            <motion.div className="app__skills-exp-item" key={experience.year}>
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className="app__skills-exp-works" key={`${experience.year}-works`}>
                {experience.works.map((work) => (
                  <React.Fragment key={work.name}>
                    <motion.div
                      data-tip
                      data-for={work.name}
                      transition={{ duration: 0.5 }}
                      className="app__skills-exp-work"
                      whileInView={{ opacity: [0, 1] }}
                    >
                      <h4 className="bold-text">{work.name}</h4>
                      <p className="p-text">{work.company}</p>
                    </motion.div>
                    <ReactTooltip
                      id={work.name}
                      effect="solid"
                      arrowColor="#fff"
                      className="skills-tooltip"
                    >
                      {work.desc}
                    </ReactTooltip>
                  </React.Fragment>
                ))}
              </motion.div>
            </motion.div>
          ))}
          <div className="app__skills-resume">
            <h3>Resume</h3>
            <a href="https://docs.google.com/document/d/1pxvs5om9OSi9uFB0SxDk3avMY2lSmev2Mdr0oe2Yp6k/edit?tab=t.0" target="_blank" rel="noopener noreferrer">
              <img src={resume} alt="Resume" width={300} />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  'app__whitebg',
);
